import { sharedEnvironment } from '@raptor-fe/core';
import { MarlinEnvironment } from './marlin-environment';

export const environment: MarlinEnvironment = {
    ...sharedEnvironment,
    baseUrl: 'https://api.raptor.development.megabus.com.au/api/',
    baseReportUrl: 'https://reports.raptor.development.megabus.com.au/api/',
    federationApiUrl: 'https://federation.raptor.development.megabus.com.au/api/',
    auditApiBaseUrl: 'https://audit.raptor.development.megabus.com.au/api/',
    staffSignInEnabled: true,
    entra: {
        tenantId: '748b5735-b385-41d2-a99d-806bb5c45789',
        clientId: '75f3a011-df91-40a5-af04-a865a6bdcb62',
        redirectUri: '',
    },
    envName: 'development',
    /**
     * The client Application Insights resource, the same one marlin-mobile sends to in this environment, which has its
     * own ingestion cap. The connection string is ingestion-only and public once it is in the bundle anyway, so
     * committing it here is deliberate.
     */
    appInsightsConnectionString:
        'InstrumentationKey=fe60d7ff-91e1-442c-bfb6-eaf5302980f9;IngestionEndpoint=https://australiaeast-1.in.applicationinsights.azure.com/;LiveEndpoint=https://australiaeast.livediagnostics.monitor.azure.com/;ApplicationId=d284ef35-9842-4be3-85bd-93dd2719f2ad',
};
